
import React from "react";
import { FaPhoneAlt } from "react-icons/fa";
import { HiOutlineLocationMarker } from "react-icons/hi";
import { HiOutlineMailOpen } from "react-icons/hi";
import { FaCheck } from "react-icons/fa6";
import { Link } from "react-router-dom";
import { AiOutlineInstagram } from "react-icons/ai";
import { PiTiktokLogoBold } from "react-icons/pi";
import { LuYoutube } from "react-icons/lu";


const Footer = () => {
  return (
    <>
      <footer id="footer" className="footer">
        <div className="container">
          <div className="subscription-wrapper">
            <div className="w-layout-hflex vertical-left-top-40px-gap">
              <img
                loading="lazy"
                src="https://res.cloudinary.com/dawcfhibj/image/upload/q_auto/f_auto/v1744881418/white_logo_btrkro.svg"
                alt=""
                className="site-logo"
              />
              {/* SOCIAL-MEDIA ICONS */}
              <div className="horizontal-left-center-15px-gap">
                <a
                  href="https://www.facebook.com/Eristartravelers/"
                  target="_blank"
                  className="social-icon-transparent"
                >
                  
                </a>
                <a
                  href="https://x.com/StarEri90400"
                  target="_blank"
                  className="social-icon-transparent twitter"
                >
                  
                </a>
                <a
                  href="https://www.pinterest.com/eristartraveagency"
                  target="_blank"
                  className="social-icon-transparent pinterest"
                >
                  
                </a>
                <a
                  href="https://www.linkedin.com/in/eri-star-b38988360/"
                  target="_blank"
                  className="social-icon-transparent linkedin"
                >
                  
                </a>
                <a
                  href="https://www.instagram.com/eristartravel/"
                  target="_blank"
                  className="social-icon-transparent instagram"
                >
                  <AiOutlineInstagram />
                </a>
                <a
                  href="https://www.tiktok.com/@eristar20"
                  target="_blank"
                  className="social-icon-transparent tik-tok"
                >
                  <PiTiktokLogoBold />
                </a>
                <a
                  href="https://www.youtube.com/channel/UC8un_cJLStmpxzorSl4bj8A"
                  target="_blank"
                  className="social-icon-transparent youtube"
                >
                  <LuYoutube />
                </a>
              </div>
            </div>
            <div className="subscribe-form w-form">
              <div className="_24px-text-white">Subscribe Newsletter</div>
              {/* Formspree Integration */}
              <form
                action="https://formspree.io/f/mwpldarw" // Replace with your Formspree endpoint
                method="POST"
                className="footer-form-block"
                aria-label="Footer Form"
              >
                <input
                  className="subscribe-input w-input"
                  maxLength="256"
                  name="email"
                  data-name="Subscribe Form"
                  aria-label="Get product updates"
                  placeholder="Enter Your Email"
                  type="email"
                  required
                />
                <input
                  type="submit"
                  value="Subscribe"
                  className="subscribe-button w-button"
                />
              </form>
              <div
                className="success-message w-form-done"
                tabIndex="-1"
                role="region"
                aria-label="Footer Form success"
              >
                <div>Thank you! Your submission has been received!</div>
              </div>
              <div
                className="error-message w-form-fail"
                tabIndex="-1"
                role="region"
                aria-label="Footer Form failure"
              >
                <div>Oops! Something went wrong while submitting the form.</div>
              </div>
            </div>
          </div>
          <div className="footer-wrapper">
            <div className="footer-columns">
              <div className="footer-block">
                <div className="footer-title">
                  <div>Pages</div>
                  <div className="_20px-primary-divider"></div>
                </div>
                <div className="footer-list-10px">
                  <Link
                    to="/"
                    aria-current="page"
                    className="footer-link w--current"
                  >
                    Home
                  </Link>
                  <Link to="/about-us" className="footer-link">
                    About Us
                  </Link>
                  <Link to="/services" className="footer-link">
                    Services
                  </Link>
                  <Link to="/tours" className="footer-link">
                    Tour
                  </Link>
                </div>
              </div>
              <div className="footer-block _2nd-block">
                <div className="footer-title">
                  <div>Services</div>
                  <div className="_20px-primary-divider"></div>
                </div>
                <div className="footer-list-10px">
                  <div className="horizontal-left-center-10px-gap">
                    <div className="primary-icon-14px">
                      <FaCheck />
                    </div>
                    <p className="_20px-white-text">Wanderlust Adventures</p>
                  </div>
                  <div className="horizontal-left-center-10px-gap">
                    <div className="primary-icon-14px">
                      <FaCheck />
                    </div>
                    <p className="_20px-white-text">Globe Trotters Travel</p>
                  </div>
                  <div className="horizontal-left-center-10px-gap">
                    <div className="primary-icon-14px">
                      <FaCheck />
                    </div>
                    <p className="_20px-white-text">Odyssey Travel Services</p>
                  </div>
                  <div className="horizontal-left-center-10px-gap">
                    <div className="primary-icon-14px">
                      <FaCheck />
                    </div>
                    <p className="_20px-white-text">Jet Set Journeys</p>
                  </div>
                  <div className="horizontal-left-center-10px-gap">
                    <div className="primary-icon-14px">
                      <FaCheck />
                    </div>
                    <p className="_20px-white-text">
                      Dream Destinations Travel
                    </p>
                  </div>
                </div>
              </div>

              <div
                id="w-node-f3d2bd98-c442-9223-dca0-662629658ea3-b75bd7b0"
                className="footer-block newsletter"
              >
                <div className="footer-title">
                  <div>Contact</div>
                  <div className="_20px-primary-divider"></div>
                </div>
                <div className="vertical-left-top _15px-gap">
                  <div className="horizontal-left-center _14px-gap">
                    <div className="footer-icon-16px-primary">
                      <HiOutlineLocationMarker />
                    </div>
                    <div className="_20px-300-secondary-paragraph">
                      Southpoint Kabalagala
                    </div>
                  </div>
                  <div className="horizontal-left-center _14px-gap">
                    <div className="footer-icon-16px-primary">
                      <FaPhoneAlt />
                    </div>
                    <div className="_20px-300-secondary-paragraph">
                      +256 709 438 944
                    </div>
                  </div>
                  <div className="horizontal-left-center _14px-gap">
                    <div className="footer-icon-16px-primary">
                      <FaPhoneAlt />
                    </div>
                    <div className="_20px-300-secondary-paragraph">
                      +256 764 070 076{" "}
                    </div>
                  </div>
                  <div className="horizontal-left-center _14px-gap">
                    <div className="footer-icon-16px-primary">
                      <HiOutlineMailOpen />
                    </div>
                    <div className="_20px-300-secondary-paragraph">
                      info@eristar.com
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <div className="container">
            <div className="space-between-block-center-on-portrait">
              <div className="footer-copyright">
                <div className="footer-copyright-text">
                  Copyright © 2025 eristar
                </div>
                
              </div>
              <div className="horizontal-left-center-20px-gap">
                <a
                  href="/utility/license"
                  className="_20px-300-secondary-paragraph"
                >
                 
                </a>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;